import { SelectNumberOption } from 'types';

import { httpClient } from './httpClient';

export type RegistrationUserOptions = Record<
  string,
  {
    name: string;
    options: SelectNumberOption[];
  }
>;

export interface LandingPopunder {
  redirect_url: string;
  add_params: Record<string, string>;
}

export interface AutoRedirectResponse {
  redirect_url: string;
  add_params: Record<string, string>;
}

export interface UserCheckResponse {
  result: boolean;
}

export const LandingApi = {
  async fetchUserOptions() {
    const { data } = await httpClient.get<RegistrationUserOptions>(
      '/register/user-options'
    );

    return data;
  },

  async fetchPopunderData() {
    const { data } = await httpClient.get<LandingPopunder>(
      '/landing/popunder/click'
    );

    return data;
  },

  async fetchPopunderDataByUser(userId: number) {
    const { data } = await httpClient.get<LandingPopunder>(
      `/landing/popunder/click?user_id=${userId}`
    );

    return data;
  },

  async fetchAutoRedirectData(prelandId: number) {
    const { data } = await httpClient.post<AutoRedirectResponse>(
      '/landing/auto-redirect',
      {
        id: prelandId,
        screen_number: 0,
      }
    );

    return data;
  },
};
